import React from 'react'
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux'

import ArticleHolder from '../ArticleHolder'

import { fetchArticle, sortItems } from '../../../../slices/article'

const ArticleView = ({ items, parent = null, depth = 0, parentZ = 0 }) => {
  const dispatch = useAppDispatch()
  const { articles, selected } = useAppSelector(state => state.article)

  const [expanded, setExpanded] = React.useState([])
  const [doneExpand, setDoneExpand] = React.useState(false)

  const toggle = React.useCallback(
    id => {
      setExpanded(old => {
        if (old.includes(id)) {
          return old.filter(oldId => oldId !== id)
        }

        return [...old, id]
      })

      dispatch(fetchArticle(id))
    },
    [dispatch]
  )

  // Reset expansion when changing articles
  React.useEffect(() => {
    setDoneExpand(false)
  }, [selected])

  // Expands folders until selected is visible
  React.useEffect(() => {
    if (doneExpand) {
      return
    }

    let id = selected
    let done = false

    while (id !== null) {
      const article = articles[id]
      if (!article) {
        // Need to fetch a parent
        if (id) {
          dispatch(fetchArticle(id))
        }
        break
      }

      // Expand this item
      if (!expanded.includes(id)) {
        const toAdd = id
        setExpanded(old => [...old, toAdd])
      }

      const parentID = article.parent?.id

      if (!parentID) {
        // At the root
        done = true
        break
      }

      // Expand
      if (!expanded.includes(parentID)) {
        setExpanded(old => [...old, parentID])
      }

      // Continue up the hierarchy
      id = parentID
    }

    if (done) {
      setDoneExpand(true)
    }
  }, [selected, articles, dispatch, expanded, doneExpand])

  const sortedItems = React.useMemo(() => {
    if (!items?.length) {
      return []
    }

    return sortItems(items)
  }, [items])

  if (!sortedItems.length) {
    return null
  }

  return (
    <>
      {sortedItems.map((item, i) => {
        const zIndex = depth === 0 ? (items.length - i) * 1000 : parentZ - i
        const isExpanded = expanded.includes(item.id)

        return (
          <ArticleHolder
            key={item.id}
            parent={parent}
            item={item}
            depth={depth}
            isExpanded={isExpanded}
            toggle={toggle}
            zIndex={zIndex}
          />
        )
      })}
    </>
  )
}

export default ArticleView
